import { mergeClasses } from '@/utils';

export const GlassContainer = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={mergeClasses('glass-effect p-4 shrink-0', className)}
      style={{ boxShadow: '0px 4px 12px 0px #64646414' }}
      {...props}
    >
      {children}
    </div>
  );
};

export const AuthGlassContainer = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={mergeClasses(
        'rounded-3xl p-8 shrink-0 bg-opacity-light-5 border border-opacity-light-30 backdrop-blur-[10px]',
        className,
      )}
      style={{ boxShadow: '0px 4px 12px 0px #64646414' }}
      {...props}
    >
      {children}
    </div>
  );
};
